var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"dc9118f308e11d8f7abb9d5f6d26f17d9c82c173"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supportapp@wavemm"]={id:"dc9118f308e11d8f7abb9d5f6d26f17d9c82c173"};
      